import { c as _c } from "react/compiler-runtime";
import { SphereIconButton } from "@components/common/sphere-icon-button";
import { EditIcon } from "@flat-ui";
import { PALETTE_VARS } from "@styles/palette-vars";
/** Icon button with edit icon, used in table cells to indicate the edit action on hover */
export function EditColumnValueIcon(t0) {
  const $ = _c(8);
  const {
    iconButtonProps,
    onClick
  } = t0;
  let t1;
  if ($[0] !== onClick) {
    t1 = event => {
      event.stopPropagation();
      onClick();
    };
    $[0] = onClick;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      visibility: "hidden"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== iconButtonProps) {
    t3 = {
      ...iconButtonProps,
      sx: t2
    };
    $[3] = iconButtonProps;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t3) {
    t4 = <SphereIconButton component={EditIcon} buttonSize="24px" iconSize="16px" onClick={t1} color={PALETTE_VARS.text.disabled} iconButtonProps={t3} />;
    $[5] = t1;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}